import React, { Component } from "react";
import { MQReqProps, MQRowProps } from "./MQRequestsListView";
import GridDataView, { GRID_SIZE } from "../DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { MQRequest } from "@eres/mortgageQuotationAPI/entities";
import {
	getMQAmount,
	getMQArea,
	getMQBank,
	getMQLandNo,
	getMQRefNo,
	getMQReqDate,
	getMQSize,
	getMQTenure,
	getMQUnitNo,
	getMQVillaName
} from "@my-dld/screens/MyDLD/MyRequest/MQRequests";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import Strings from "@my-dld/assets/strings";
import { ImperialSystem } from "@my-dld/utils/UnitUtils";
import { getOPLabel } from "../Portfolio/PropertyTable";

interface State {
	searchKey?: string;
	page: number;
}

class MQRequestsGridView extends Component<MQReqProps, State> {
	constructor( props: MQReqProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { type, items, unit } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		let Row = LandItem;
		switch ( type ) {
			case TabuPropertyType.VILLA:
			case TabuPropertyType.BUILDING:
				Row = VillaItem;
				break;
			case TabuPropertyType.UNIT:
				Row = UnitItem;
				break;
		}
		return <GridDataView
			title={ `${ getOPLabel( type ) } (${ items.length })` }
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: MQRequest ) => {
				return <Row
					key={ item.mortgageRequestReference }
					item={ item }
					isSqFt={ unit.Id === ImperialSystem.Id }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items, unit } = this.props;
		if ( sKey ) {
			return items.filter( ( item: MQRequest ) => {
				const filterKeys: string[] = [];
				if ( item.property.propertyType === TabuPropertyType.LAND ) {
					filterKeys.push( getMQLandNo( item ) );
				}
				if ( item.property.propertyType === TabuPropertyType.VILLA || TabuPropertyType.BUILDING ) {
					filterKeys.push( getMQVillaName( item ) );
				}
				if ( item.property.propertyType === TabuPropertyType.UNIT ) {
					filterKeys.push( getMQUnitNo( item ) );
				}
				filterKeys.push( getMQArea( item ) );
				filterKeys.push( getMQSize( item, unit.Id === ImperialSystem.Id ) );
				filterKeys.push( getMQReqDate( item ) );
				filterKeys.push( getMQRefNo( item ) );
				filterKeys.push( getMQAmount( item ) );
				filterKeys.push( getMQTenure( item ) );
				filterKeys.push( getMQBank( item ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: MQRequest[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function LandItem( props: MQRowProps ) {
	const { item } = props;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getMQLandNo( item ) }</span>
							<span>{ Strings.land_num_label }</span>
						</div>
						<div className="property-status-position">
							<span>{ getMQRefNo( item ) }</span>
							<span>{ Strings.reference_number }</span>
						</div>
					</div>
					<RenderCommon { ...props }/>
				</div>
			</div>
		</div>
	</div>;
}

function VillaItem( props: MQRowProps ) {
	const { item } = props;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getMQVillaName( item ) }</span>
							<span>{ Strings.name }</span>
						</div>
						<div className="property-status-position">
							<span>{ getMQRefNo( item ) }</span>
							<span>{ Strings.reference_number }</span>
						</div>
					</div>
					<RenderCommon { ...props }/>
				</div>
			</div>
		</div>
	</div>;
}

function UnitItem( props: MQRowProps ) {
	const { item } = props;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getMQUnitNo( item ) }</span>
							<span>{ Strings.Unit_Number_Label }</span>
						</div>
						<div className="property-status-position">
							<span>{ getMQRefNo( item ) }</span>
							<span>{ Strings.reference_number }</span>
						</div>
					</div>
					<RenderCommon { ...props }/>
				</div>
			</div>
		</div>
	</div>;
}

function RenderCommon( props: MQRowProps ) {
	const { item, isSqFt } = props;
	return <>
		<div className="row no-gutters property-card-detail">
			<div className="col-12">
				<span>{ getMQArea( item ) }</span>
				<span>{ Strings.area_label }</span>
			</div>
		</div>
		<div className="row no-gutters property-card-detail">
			<div className="col-6">
				<span>{ getMQReqDate( item ) }</span>
				<span>{ Strings.submission_date }</span>
			</div>
			<div className="col-6">
				<span>{ getMQSize( item, isSqFt ) }</span>
				<span>{ Strings.size }</span>
			</div>
		</div>
		<div className="row no-gutters property-card-detail">
			<div className="col-6">
				<span>{ getMQAmount( item ) }</span>
				<span>{ Strings.amount }</span>
			</div>
			<div className="col-6">
				<span>{ getMQTenure( item ) }</span>
				<span>{ Strings.tenure }</span>
			</div>
		</div>
		<div className="row no-gutters property-card-detail">
			<div className="col-12">
				<span>{ getMQBank( item ) }</span>
				<span>{ Strings.bank_name }</span>
			</div>
		</div>
	</>;
}

export default MQRequestsGridView;
